// config
import { CountryISO } from 'ngx-intl-tel-input';
import { SideMenu } from './models/restaurant.model';
import { Address, DeliveryAddress } from './models/order.model';

export const BASE_URL_PATH = 'merchants';
export const GROUP_BASE_URL_PATH = 'groups';
export const GROUP_LOCATIONS_BASE_URL_PATH = 'locations/groups';
export const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NO_SELECTED_CARD = 'different';
// ${environment.merchantId}

// Storage variables
export const STORAGE_CUSTOMER_DATA = 'customerData';
export const STORAGE_TAB_DATA = 'tabData';

export const PHONE_COUNTRIES = [
  CountryISO.UnitedStates,
  CountryISO.Australia,
  CountryISO.Canada,
  CountryISO.UnitedKingdom,
  CountryISO.PuertoRico,
  CountryISO.Guam,
  CountryISO.USVirginIslands,
  CountryISO.NorthernMarianaIslands,
  CountryISO.AmericanSamoa,
];

export const SERVICE_ITEM_MERCHANTS = ['3P74X474YMNDY', 'ZG3AZNS505J6G'];
export const SERVICE_ITEM_LOCATIONS = ['LYFVCR2S54Q0Z'];
export const ORDER_READY_SPECIAL_MERCHANTS = ['kitchenlabs'];

// Stone Creek config
export const STONE_CREEK_MERCHANT_ID = 'CFBWC96K81379';
export const STONE_CREEK_ABOUT_URL = 'https://www.stonecreekcoffee.com/our-story/';
export const STONE_CREEK_LEARN_MORE_URL = 'https://www.stonecreekcoffee.com/2021/10/26/new-mobile-app-coffee-geek-rewards/';

export const IMG_200 = '200x200/';
export const IMG_500 = '500x500/';
export const SQUARE_PROCESSOR = 'https://images-production-f.squarecdn.com/unsafe/';
export const SPICE_KITCHEN_IMG_PROCESS = 'https://res.cloudinary.com/kyoo-inc/image/fetch/e_bgremoval,q_100,b_black,e_vignette:30/';
export const NO_IMG_URL = './assets/icon/noimage.svg';

export const ATRIUM_LOGIN = 'atriumSuccess';

export const CITY_FLAVOR_LOCATIONS = [
  'LJX9BRZRA497B',
  'LJY848EBEWBC3',
  'L8ZJDN55J7VA1',
  'L00Q8JCK377VT',
  'A6M966PYW6C1C',
  'LR6D2VC0WNM1E',
  'LE8YKANPRF1ZD',
  '1GSTTH8CT7RW3',
  'LYFQYB2NW72GW',
  'LFF735NAD7KMF',
  'A917PM9NK3XWA',
  'LAVCD4JKA34QM',
  'F2ZDXWRVZMXKJ',
  'LWC9TJSGM4QWW',
  'LBA7YWJHH2RJX',
  'LHTNQQXKD0RYK',
  'LTHS7FFRH6225',
  'LVNA7DQQC0DEK',
  'LRQG7DF10FFJ5',
  'LKFP9HYRCB3QT',
  'M87DRCWGVE72P',
  'L3PX6RW9CHEDG',
  'L27TP9N566W1K',
  'LPWTZMYYYZ0T9',
  'L3KMDBEVEZ8PG',
  'LN2K9W39R43KY',
  'LY4XRYAPKYTV6',
  'LTYD3KJQ5ZV1H',
  '2WFXT1822Z0FY',
  'L2WNAE8CABQ8X',
  'LKK0XG3GA02V5',
  'D259GF98MGGHJ',
  'LWCPFPPHJXVPB',
  'LWJM8ZZAN1SB1',
  'LD25CK0VV7A62',
  'L6364PF41KV15',
  'L9EQDS6B1KMBG',
  'LV3HSS8ZSJR63',
  'L2BYTHYAWG29A',
  'L1BFKE1BZERDA',
  'LMRA6X0NW0V1H',
  'LPDAZR45B84P2',
  'L3QVX574ASQ7K',
  'LMWH7B0CD44FA',
  'LYRJ86JQDQCNY',
  'LHXE6PEJYKFJX',
  'LMTSDQGAWBEGC',
  'L9G0XMEG4HTAR',
  'LWXQ602HBEACC',
  'L6NBC60Z0TT27',
  'LBQ3G4N1QRSJE',
  'L9E4BHS5JZTSF',
  'L3B4W44Z7TN49',
  'L6HSF3JZ573AM',
  'LN40X1Z3ANAXM',
  'LY65QTMVC5WBW',
  'LSVFJZ2B7WZVT',
  'BQECV8SJADEH6',
  'LJYS4S3F3FWGX',
  'L0GK4R7CBJA5X',
  'LYM7DM0XN8F6M',
  'LAFCXWM1QY7NP',
  'LNJDNPHVDBTCE',
  'LM3MVYA995PSX',
  'LEKF4SVBEHXZC',
  'L27K1VAEC03SZ',
  'LPJX7D65YRMQ2',
  'LKXYXRFB6A8DK',
  'L8ZE2G4VEH4MC',
  'LF246W0424G8B',
  'L0C6GAPF0V151',
  'LF6Z9VRE2N3B9',
  'LPE7317E8QV5M',
  'LZYPDDFJYBAG8'
];

export const SIDE_MENU: SideMenu[] = [
  new SideMenu(1, 'Home', false, false),
  new SideMenu(2, 'Cart', false, true),
  new SideMenu(3, 'Rewards', true, false),
  new SideMenu(4, 'Order History', false, false),
  new SideMenu(5, 'About Stone Creek', false, false),
  new SideMenu(6, 'All Locations', false, false),
];
